__turbopack_context__.v({
  "tooltip": "Tooltip-module__qAi1oa__tooltip",
  "tooltipArrow": "Tooltip-module__qAi1oa__tooltipArrow",
  "tooltipArrow_bottom": "Tooltip-module__qAi1oa__tooltipArrow_bottom",
  "tooltipArrow_center": "Tooltip-module__qAi1oa__tooltipArrow_center",
  "tooltipArrow_end": "Tooltip-module__qAi1oa__tooltipArrow_end",
  "tooltipArrow_left": "Tooltip-module__qAi1oa__tooltipArrow_left",
  "tooltipArrow_right": "Tooltip-module__qAi1oa__tooltipArrow_right",
  "tooltipArrow_start": "Tooltip-module__qAi1oa__tooltipArrow_start",
  "tooltipArrow_top": "Tooltip-module__qAi1oa__tooltipArrow_top",
});
